module.exports = __webpack_public_path__ + "44d2b5ffe6c0e9b8dc867df42d56dc40.svg";